import Axios from 'axios';
import { DashboardInicializacionModel } from '../models/DashboardModels';
import { DashboardPanelIcoValorModel } from '../models/DashboardModels';
import { DashboardPanelIcoValor2Model } from '../models/DashboardModels';
import { DashboardPanelLista3CModel } from '../models/DashboardModels';
import { DashboardLinkPopUpModel } from '../models/DashboardModels';

export default class DashboardService {

    constructor() {
    }

    async GetDashboardData() {
        var res = await Axios.get('/api/Dashboard/GetDashboardPanels');
        if (res.data.success) {
            return res.data.data.map((itm: any) => new DashboardInicializacionModel(itm));
        }
        return null;
    }

    async GetDashboardInstalationListByPanel(idNPanel:any) {
        var res = await Axios.get('/api/Dashboard/GetDashboardInstalationListByPanel', { params: {idNPanel}});
        if (res.data.success) {
            return res.data.data.map((itm: any) => itm);
        }
    }

    async GetPanelData_IcoValor(idNPanel: any, fldBPortada: any) {
        var res = await Axios.get('/api/Dashboard/GetPanelData_IcoValor', { params: { idNPanel, fldBPortada } });
        if (res.data.success) {
            return res.data.data.map((itm: any) => new DashboardPanelIcoValorModel(itm));
        }
        return null;
    }

    async GetPanelData_IcoValor2(idNPanel: any, fldBPortada: any) {
        var res = await Axios.get('/api/Dashboard/GetPanelData_IcoValor2', { params: { idNPanel, fldBPortada } });
        if (res.data.success) {
            return res.data.data.map((itm: any) => new DashboardPanelIcoValor2Model(itm));
        }
        return null;
    }

    async GetPanelData_Lista3C(idNPanel: any, fldBPortada: any) {
        var res = await Axios.get('/api/Dashboard/GetPanelData_Lista3C', { params: { idNPanel, fldBPortada } });
        if (res.data.success) {
            return res.data.data.map((itm: any) => new DashboardPanelLista3CModel(itm));
        }
        return null;
    }

    async GetLinkPopUpData(idNPanel: any, idNKey:any ) {
        var res = await Axios.get('/api/Dashboard/getlinkpopupdata', { params: { idNPanel, idNKey } });
        if (res.data.success) {
            return res.data.data.map((itm: any) => new DashboardLinkPopUpModel(itm));
        }
    }


}